<!--
 * @Description:联系人
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-10-25 13:56:09
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :title="form.id ? '编辑' : '新增'"
    class="clueMerge"
    width="870px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="form" ref="formRef" v-if="visible">
      <dc-layout-card :span="12">
        <dc-form-item
          name="contactType"
          label="联系人类型"
          :rules="{
            message: '请选择',
            required: true
          }"
        >
          <a-select
            v-model:value="form.contactType"
            :options="dataConfig.contactTypeEnum"
            placeholder="请选择"
            allow-clear
          />
        </dc-form-item>
        <dc-form-item
          name="name"
          :rules="[
            {
              required: true,
              message: '请输入'
            },
            {
              validator: concatNameValidate
            }
          ]"
          label="联系人名称"
        >
          <CosInput v-model:value="form.name" placeholder="请输入" :maxlength="50" />
        </dc-form-item>
        <dc-form-item label="手机号" class="form-item_compact">
          <a-input-group compact>
            <ParamCodesSelect
              :options="paramCodeData.fbu_area_code"
              v-model:value="form.mobileRegion"
              style="width: 33%"
            />
            <a-form-item
              style="width: 67%"
              class="last-compact"
              name="mobile"
              :rules="{
                validator: (rule, value) => contactValidate(rule, value, form, formRef)
              }"
            >
              <CosInput v-model:value="form.mobile" placeholder="请输入，联系方式必填其一" />
            </a-form-item>
          </a-input-group>
        </dc-form-item>
        <dc-form-item
          name="email"
          label="邮箱"
          :rules="[
            {
              validator: (rule, value) => contactValidate(rule, value, form, formRef)
            }
          ]"
        >
          <CosInput v-model:value="form.email" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="wechat"
          label="微信号"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <CosInput v-model:value="form.wechat" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="qq"
          label="QQ号"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <CosInput v-model:value="form.qq" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item label="固定电话" class="form-item_compact">
          <a-input-group compact>
            <ParamCodesSelect
              :options="paramCodeData.fbu_area_code"
              v-model:value="form.telRegion"
              style="width: 33%"
            />
            <a-form-item
              :span="24"
              style="width: 67%"
              class="last-compact"
              name="tel"
              :rules="{
                validator: (rule, value) => contactValidate(rule, value, form, formRef)
              }"
            >
              <CosInput v-model:value="form.tel" placeholder="请输入，联系方式必填其一" />
            </a-form-item>
          </a-input-group>
        </dc-form-item>
        <dc-form-item label="性别">
          <CosSelect v-model:value="form.sex" :options="dataConfig.genderEnum" placeholder="请选择" allow-clear />
        </dc-form-item>
        <dc-form-item label="角色">
          <CosSelect
            v-model:value="form.jobRole"
            :options="dataConfig.linkRoleTypeEnum"
            placeholder="请选择"
            allow-clear
          />
        </dc-form-item>
        <dc-form-item label="部门职务">
          <CosInput v-model:value="form.jobDuty" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="传真号">
          <CosInput v-model:value="form.fax" placeholder="请输入" :maxlength="50" />
        </dc-form-item>
        <dc-form-item label="备注" :span="24">
          <CosTextarea v-model:value="form.remark" placeholder="请输入" :maxlength="2000" />
        </dc-form-item>
      </dc-layout-card>
    </a-form>
  </cos-modal>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import dataConfig from '@/views/gucangSales/commonEnum/dataConfig'
import { customerContactAdd, customerContactEdit } from '@/api/gucangSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { contactValidate, concatNameValidate } from '@/utils/validate'
import { listByParamCodes } from '@/api/common'
import { cloneDeep } from 'lodash-es'
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PotentialItem['contact']>({})
const paramCodeData = ref<{
  fbu_area_code: []
}>({
  fbu_area_code: [] // 电话区号
})
const emit = defineEmits(['success'])
const props = defineProps({
  contactRefId: {
    type: String
  }
})
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_area_code']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const success = (type: 'add' | 'edit') => {
  emit('success', type)
}
const toggle = (row: PotentialItem['contact']) => {
  console.log(row)
  form.value = row ? cloneDeep(row) : {}
  visible.value = true
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      if (form.value?.id) {
        await customerContactEdit(form.value)
        message.success('编辑成功')
        success('edit')
      } else {
        await customerContactAdd({
          ...form.value,
          contactRefId: props.contactRefId
        })
        message.success('新增成功')
        success('add')
      }
      loading.value = false
      visible.value = false
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default {
  name: 'ContactsModal'
}
</script>
